<template>
  <div class="p-3 bg-teal-100">
    <button @click="$refs['pdf'].click()" class="px-5 py-2 text-xl bg-teal-200 text-teal-600 border-teal-600 rounded-lg">Upload PDF</button>
    <input v-show="false" type="file" ref="pdf" @change="onChangeFileSelector" multiple accept="application/pdf" name="pdf">
    <input placeholder="Keywords to Scan" @keyup.enter="analyseFiles" type="text" v-model="term" class="px-5 py-2 text-xl bg-gray-200 text-gray-600 border-gray-600 rounded-lg mx-2" />
    <button @click="analyseFiles" class="px-5 py-2 text-xl bg-teal-200 text-teal-600 border-teal-600 rounded-lg mx-2">Analyse PDF</button>
    <p :key="li + 'row'" v-for="(row, li) in table">
      <!-- <pre>{{ row }}</pre> -->
      Frequency: [{{ row.result }}]
      <a class="underline inline-block px-3 py-1" target="_blank" :href="row.pdf.url">{{ row.pdf.name }} ...</a>
    </p>
    <p :key="li + 'log'" v-for="(log, li) in logs">
      {{ JSON.stringify(log) }}
    </p>
    <h2 class="py-2 px-0" v-if="tasks.length > 0">
      Running Tasks
    </h2>
    <p :key="li + 'tasks'" v-for="(log, li) in tasks">
      {{ JSON.stringify(log) }}
    </p>
  </div>
</template>

<script>
import * as API from '../pdfAPI'
import SparkMD5 from 'spark-md5'
export default {
  data () {
    return {
      tasks: [],
      term: '',
      logs: [],
      table: false
    }
  },
  methods: {
    async onChangeFileSelector (evt) {
      const files = evt.target.files
      console.log(files)
      for (var i = 0; i < files.length; i += 1) {
        if (files[i]) {
          await this.eachUpload(files[i])
        }
      }
    },
    // async checkItem (file) {
    //   return API.checkItem(file)
    // },
    async analyseFiles () {
      let done = false
      const tout = setInterval(() => {
        if (done) {
          clearInterval(tout)
          return
        }
        API.getRunningTask()
          .then((v) => {
            this.tasks = v
          })
      }, 1000)
      try {
        const res = await API.analyseFiles({ term: this.term })
        this.table = res
        clearInterval(tout)
        done = true

        this.tasks = await API.getRunningTask()
      } catch (e) {
        clearInterval(tout)
        done = true
      }
    },
    async eachUpload (file) {
      return new Promise((resolve) => {
        const log = {
          file: file.name.slice(0, 20) + '...',
          state: 'ready'
        }
        this.logs.unshift(log)
        const formData = new FormData()
        // formData.append(`data`, JSON.stringify({
        //   filename: '',
        //   hash: '',
        //   info: {}
        // }))

        var reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onloadend = async () => {
          console.log(reader.result)
          const md5 = SparkMD5.ArrayBuffer.hash(reader.result)

          const hasDuplication = await API.checkHasMD5({ md5 })
          if (hasDuplication) {
            log.state = 'duplicated, not uploaded'
            resolve()
            return
          }

          formData.append('files', file)
          log.state = 'uploading pdf'
          const fileRes = await API.uploadFile({ formData })
          const filer = fileRes[0]
          log.state = 'registering paper'
          await API.createPDF({ pdf: filer, md5, text: '', meta: {} })
            .then((pdfRes) => {
              console.log('uploaded pdf entry')
              console.log(pdfRes)
              resolve()
            }, () => {
              console.log('removing file')
              return API.deleteFile({ fileID: filer._id })
                .then(() => {
                  resolve()
                })
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
